export const media = {
  location: '/static/images/home-valuation/location.svg',
  locationMobile: '/static/images/home-valuation/location-mobile.svg',
  rightArrow: '/static/images/home-valuation/right-arrow.svg',
  phone: '/static/icons/phone.svg',
  tick: '/static/images/home-valuation/tick.svg',
};
